var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchCoursesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.057 0 0 6.057 0 13.5C0 20.943 6.057 27 13.5 27C16.7891 27 19.8057 25.816 22.1504 23.8535C22.4353 24.1384 31.7119 33.416 31.9434 33.6484C32.4134 34.1184 33.1765 34.1184 33.6465 33.6484C34.1165 33.1784 34.1165 32.4153 33.6465 31.9453C33.415 31.7129 24.1384 22.4353 23.8535 22.1504C25.816 19.8057 27 16.7891 27 13.5C27 6.057 20.943 0 13.5 0ZM13.5 1C20.392 1 26 6.608 26 13.5C26 20.392 20.392 26 13.5 26C6.608 26 1 20.392 1 13.5C1 6.608 6.608 1 13.5 1Z",
    fill: "#E87975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCoursesIcon);
export default __webpack_public_path__ + "static/media/Search_Courses_Icon.a6e2383d6362cbce3b35fe24366f8035.svg";
export { ForwardRef as ReactComponent };